import React from 'react';

import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';

interface ISearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  ariaLabel?: string;
}

export const SearchField: React.FC<ISearchFieldProps> = ({
  value,
  onChange,
  placeholder = 'Search',
  ariaLabel
}) => (
  <TextField
    value={value}
    onChange={(e) => onChange(e.target.value)}
    placeholder={placeholder}
    size="small"
    fullWidth
    variant="outlined"
    inputProps={{ 'aria-label': ariaLabel || placeholder }}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <SearchIcon fontSize="small" color="disabled" />
        </InputAdornment>
      ),
      endAdornment: value ? (
        <InputAdornment position="end">
          <IconButton size="small" aria-label="Clear search" onClick={() => onChange('')}>
            <ClearIcon fontSize="small" />
          </IconButton>
        </InputAdornment>
      ) : undefined
    }}
  />
);
